import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { SharedDashboardComponent } from './shared-dashboard.component';
import { DashboardDraggableOptionsComponent } from '../dashboard-draggable-options/dashboard-draggable-options.component';
import { TranslateModule } from '@ngx-translate/core';
import { HttpClient, HttpClientModule } from '@angular/common/http';
import { TranslateHttpLoader } from '@ngx-translate/http-loader';
import { NO_ERRORS_SCHEMA } from '@angular/core';
import { DashboardRoutingModule } from './dashboard-routing.module';
import { NavbarSidebarModule } from '../navbar-sidebar/navbar-sidebar.module';
import { NavbarModule } from 'ng-uikit-pro-standard';
import { DxButtonModule, DxDataGridModule, DxPopupModule, DxScrollViewModule, DxSortableModule, DxTemplateModule, DxDropDownButtonModule, DxTagBoxModule } from 'devextreme-angular';
import { MdbGlobalModule } from '../mdb-global.module';
import { FormsModule, ReactiveFormsModule,  } from '@angular/forms';
import { DashboardPageComponent } from 'src/app/pages/dashboard/dashboard-page/dashboard-page.component';

export function createTranslateLoader(http: HttpClient) {
  return new TranslateHttpLoader(http, './assets/i18n/', '.json');
}

@NgModule({
  declarations: [
    SharedDashboardComponent,
    DashboardDraggableOptionsComponent,
    DashboardPageComponent
  ],
  imports: [
    CommonModule,
    DashboardRoutingModule,
    MdbGlobalModule,
    DxTemplateModule,
    DxTagBoxModule,
    DxButtonModule,
    DxScrollViewModule,
    DxPopupModule,
    DxDataGridModule,
    DxSortableModule,
    DxDropDownButtonModule
    // NavbarSidebarModule,
  ],
  exports: [SharedDashboardComponent],
  schemas: [NO_ERRORS_SCHEMA]
})
export class DashboardModule { }
